<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <path class="a" :class="{green, gray}" d="M7,0l7,14H0Z" transform="translate(14 14) rotate(180)"/>
  </svg>
</template>

<script>
export default {
  name: "TrendDownIcon",
  props: {
    green: {
      type: Boolean,
      default: false
    },
    gray: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.a {
  fill: #dd227b;

  &.green {
    fill: #57b98f;
  }

  &.gray {
    fill: #707070;
  }

}
</style>
